/*eslint @typescript-eslint/no-magic-numbers: ["error", {"ignore": [8212]}]*/
/* ALll constants content should go here*/

const ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin'
const ACCESS_CONTROL_ALLOW_ORIGIN_LOGGER = 'ACCESS_CONTROL_ALLOW_ORIGIN'
export const EM_DASH = '—'
const NAV_ITEM_PROD_TOOL_SILO = 'CBD_NAV_ProdTools'
const NAV_ITEM_MY_HUB_SILO = 'CBD_NAV_HUB'
const GLOBAL_HEADER_NAVBAR_SCRIPT_TAG_ID = 'globalHeaderNavbarScript'
const SCRIPT_TYPE = 'text/javascript'
export const FOI = 'FOI'
export const OPEN = 'open'
export const CLOSED = 'closed'
export const TARGET = 'Target'
export const DATA_UNAVAILABLE = 'Data Unavailable'
export const TRUST = 'Trust'
export const FUND_OF_FUND = 'Fund of Fund'
export const ADJEXPRTPC = 'ADJEXPRTPC'
export const ADJWTDEXPC = 'ADJWTDEXPC'
export const NOTE = 'Note'
export const MONTH_END_RETURN_NAV = 'monthEndReturnNAV'
export const MONTH_END_RETURN = 'monthEndReturn'
export const RTOT = 'RTOT'
export const RFEE = 'RFEE'
export const MARKET = 'MARKET'
export const RMKT = 'RMKT'
export const CMLT = 'CMLT'
export const ETF = 'etf'
export const INSTITUTIONAL_ASSET_MANAGEMENT_IAM_FAS =
  'Institutional Asset Management (IAM/FAS)'
export const INFLATION_PROTECTED_BOND = 'Inflation-Protected Bond'
export const MONTH_END_RETURN_MARKET_ETF = 'monthEndReturnsMarketETF'
export const COLLECTIVE_INVESTMENT_TRUST = 'Collective Investment Trust (CIT)'
export const STABLE_VALUE = 'Stable Value'
export const UNKNOWN = 'Unknown'
export const SESSION_STORAGE_CONSTANTS_CAAS_CONTENT = 'caasContent'
export const DEFAULT_PRODUCT_TYPE = 'allFunds'
export const DEVELOPED = 'developed'
export const DIVIDEND = 'dividend'
export const GLOBAL = 'global'
export const NON_US = 'nonUS'
export const TICK = 'TICK'
export const BENCHMARK_ID = '0000022448'
export const BENCHMARK_ASSOCIATION_TYPE = 'FBPC'
export const FUND_STATUS = 'ACTV'
export const TIME_PERIOD_CODE = 'M'
export const GET = 'GET'
export const PERFORMANCE = 'monthEndReturnNAV'
export const PERFORMANCE_MARKET_ETF = 'monthEndReturnsMarketETF'
export const FUND_LITERATURE = 'literature'
export const EQUITY_INDEX = 'equityIndex'
export const FIXED_INCOME_INDEX = 'fixedIncomeIndex'
/*Adobe Constants*/
export const PERFORMANCE_VALUE = 'performance'
export const PAGE_ID = 'fundlist'
export const SUB_SECTION = 'none'
export const SECTION = 'investments'
export const REAL_ESTATE = 'Real Estate'
export const TAB_NAME = 'Performance'
export const DOWNLOAD_ACTIVATED = 'Download button activated'
export const DOWNLOAD_DEACTIVATED = 'Download button deactivated'
export const NOT_AVAILABLE = 'Not Available'
export const RETURN_TYPE_MONTH_END = 'monthEndReturn'
export const FUND_PERFORMANCE = 'Fund Performance'
export const LITERATURE_FUND = 'Fund Literature'
export const AGGREGATE_VIEWS = 'Aggregate Views'
export const USER_DETECTED = 'userDetected'
export const LOGGED_IN = 'logged in'
export const LOGGED_OUT = 'logged out'
export const PRODUCT_TYPE = 'productType'
export const YTD_RETURN = 'YTD Return'
export const YTD_RETURN_VAL = 'ytdReturns'
export const FUND_NAME = 'fundName'
export const PERCENT_SIGN = '%'
export const AEM_ERROR_HEADER =
  'Something went wrong: the page you are looking for is temporarily unavailable.'
export const AEM_ERROR_CONTENT_ONE =
  'We are sorry for this inconvenience. Please try again later.'
export const AEM_ERROR_CONTENT_TWO = 'You can try navigating again. Go to'
export const AEM_ERROR_CONTENT_THREE = 'Vanguard’s Institutional homepage'
export const AEM_ERROR_CONTENT_FOUR = 'and start from there.'
export const CBD_NAV_INVESTMENTS = 'CBD_NAV_INVESTMENTS'
export const FILTERS_EXPANDED = ' Active and  Filters expanded'
export const FILTERS_COLLAPSED = ' Active and  Filters collapsed'
export const OPEN_FACT_SHEET = 'Open FactSheet'
export class ConstantContent {
  static ACCESS_CONTROL_ALLOW_ORIGIN = ACCESS_CONTROL_ALLOW_ORIGIN
  static ACCESS_CONTROL_ALLOW_ORIGIN_LOGGER = ACCESS_CONTROL_ALLOW_ORIGIN_LOGGER
  static EM_DASH = EM_DASH
  static NAV_ITEM_PROD_TOOL_SILO = NAV_ITEM_PROD_TOOL_SILO
  static GLOBAL_HEADER_NAVBAR_SCRIPT_TAG_ID = GLOBAL_HEADER_NAVBAR_SCRIPT_TAG_ID
  static SCRIPT_TYPE = SCRIPT_TYPE
  static NAV_ITEM_MY_HUB_SILO = NAV_ITEM_MY_HUB_SILO
}
